import ztComponent from './ztOffCanvas.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
